// src/index.js  ← replace your existing index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { MasterDataProvider } from './context/MasterDataContext';
import './App.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MasterDataProvider>
      <App />
    </MasterDataProvider>
  </React.StrictMode>
);